
export function getLatest<T extends { revision: number }>(revisions: T[]) {
  if (revisions.length === 0) {
    return undefined;
  }
  return revisions.reduce((latest, current) =>
    latest.revision > current.revision ? latest : current,
  );
}
